import { request } from '@langlois/request';

export async function deleteMembership ({ commit }, membershipId) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/membership/${membershipId}`);

		const response = await request.delete(url);

		if (response.ok) {
			return commit(`delete`, membershipId);
		}

		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while deleting the membership.`,
			type: `warning`
		}, { root: true });
	} catch (e) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while deleting the membership.`,
			type: `warning`
		}, { root: true });
	}
}
